"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8624],{

/***/ 2828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Agent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var Agent = function Agent() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Agent);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.phone = model.phone || null;
    this.clientId = model.clientId || null;
    this.logo = this.id && model.clientId && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(model.clientId, "/agents/").concat(this.id, "/logo.png").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.agentTours = model.agentTours || [];
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.permissionId = model.permissionId || null;
    this.agentPermission = model.agentPermission || null;
};


/***/ }),

/***/ 42725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "An": function() { return /* binding */ TagRes; },
/* harmony export */   "Qy": function() { return /* binding */ TagType; }
/* harmony export */ });
/* unused harmony export TagNavigationType */
var TagType;
(function(TagType) {
    TagType["None"] = "none";
    TagType["Text"] = "text";
    TagType["Image"] = "image";
    TagType["Gallery"] = "gallery";
    TagType["Music"] = "music";
    TagType["Video"] = "video";
    TagType["Iframe"] = "iframe";
    TagType["Tab"] = "tab";
    TagType["Panorama"] = "panorama";
    TagType["Menu"] = "menu";
    TagType["Matterport"] = "matterport";
    TagType["MatterportInstant"] = "matterport-instant";
    TagType["Treedis"] = "treedis";
    TagType["VideoChat"] = "video-chat";
    TagType["ConferenceChat"] = "conference-chat";
    TagType["Navigation"] = "navigation";
})(TagType || (TagType = {}));
var TagNavigationType;
(function(TagNavigationType) {
    TagNavigationType["Menu"] = "menu";
    TagNavigationType["Polygon"] = "polygon";
    TagNavigationType["Tag"] = "tag";
})(TagNavigationType || (TagNavigationType = {}));
var TagRes;
(function(TagRes) {
    TagRes["Percentage"] = "percentage";
    TagRes["Pixels"] = "pixels";
})(TagRes || (TagRes = {}));


/***/ }),

/***/ 26978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ol": function() { return /* binding */ AdRes; },
  "lC": function() { return /* binding */ AssetPageType; },
  "Bg": function() { return /* binding */ CustomButtonTypeOpenAsType; },
  "Oj": function() { return /* binding */ Tour; },
  "zz": function() { return /* binding */ TourMode; },
  "v": function() { return /* binding */ TourType; },
  "YO": function() { return /* binding */ TourTypeURL; }
});

// UNUSED EXPORTS: TourAddons, TourStatus, UnitSystem, WeekDays

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
;// CONCATENATED MODULE: ./_models/Client.tsx



var Client = function Client() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, Client);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.linkedin = model.linkedin || null;
    this.facebook = model.facebook || null;
    this.instagram = model.instagram || null;
    this.twitter = model.twitter || null;
    this.whitelabelId = model.whitelabelId || null;
    this.whitelabelLogo = model.whitelabelLogo || null;
    this.rtl = model.rtl || false;
    this.googleViewId = model.googleViewId || null;
    this.fbPixel = model.fbPixel || null;
    this.tours = model.tours || [];
    this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
    this.logo = this.id && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/logo.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.watermark = this.id && model.watermark ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/watermark.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.folders = model.folders || [];
    this.videoCredits = model.videoCredits || 0;
    this.monthlyVideoCredits = model.monthlyVideoCredits || 0;
    this.subscriptionId = model.subscriptionId || null;
    this.user = model.user || null;
    this.subscriptionType = model.subscriptionType || null;
    this.clientPermission = model.clientPermission || {};
    this.paypalClientId = model.paypalClientId || null;
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.meetingSlotMinutes = model.meetingSlotMinutes || 10;
    this.meetingSlotPpl = model.meetingSlotPpl || 5;
};

// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
;// CONCATENATED MODULE: ./_models/User.tsx



var UserSubscription;
(function(UserSubscription) {
    UserSubscription["Trial"] = "trial";
    UserSubscription["Month"] = "month";
    UserSubscription["Year"] = "year";
    UserSubscription["Pay"] = "pay";
})(UserSubscription || (UserSubscription = {}));
var UserType;
(function(UserType) {
    UserType["Admin"] = "admin";
    UserType["User"] = "user";
})(UserType || (UserType = {}));
var Mode;
(function(Mode) {
    Mode["Regular"] = "regular";
    Mode["Conference"] = "conference";
    Mode["Game"] = "game";
    Mode["Ticket"] = "ticket";
})(Mode || (Mode = {}));
var User = function User() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, User);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.country = model.country || null;
    this.type = model.type || null;
    this.videoCredits = model.videoCredits || 0;
    this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
    this.profile = this.id && model.profile ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/profile.jpg").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.subscription = model.subscription || UserSubscription.Trial;
    this.paypalEmail = model.paypalEmail || null;
    this.whitelabelId = model.whitelabelId || null;
    this.logo = this.id && this.whitelabelId ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/logo.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.domainUrl = model.domainUrl || "";
    this.adminUrl = model.adminUrl || "";
    this.whitelabelEmail = model.whitelabelEmail || "";
    this.mpSDK = model.mpSDK || "295ba0c0f04541318359a8e75af33043";
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.username = model.username || null;
    this.refer = model.refer || null;
    this.company = model.company || null;
    this.admin = model.admin || null;
    this.googleViewId = model.googleViewId || null;
};

;// CONCATENATED MODULE: ./_models/Tour.tsx

/* eslint-disable camelcase */ 




var TourStatus;
(function(TourStatus) {
    TourStatus["Idle"] = "idle";
    TourStatus["Ready"] = "ready";
    TourStatus["Error"] = "error";
    TourStatus["Pay"] = "pay";
})(TourStatus || (TourStatus = {}));
var TourMode;
(function(TourMode) {
    TourMode["DOLLHOUSE"] = "mode.dollhouse";
    TourMode["FLOORPLAN"] = "mode.floorplan";
    TourMode["INSIDE"] = "mode.inside";
    TourMode["OUTSIDE"] = "mode.outside";
    TourMode["TRANSITIONING"] = "mode.transitioning";
})(TourMode || (TourMode = {}));
var UnitSystem;
(function(UnitSystem) {
    UnitSystem["Metric"] = "metric";
    UnitSystem["Imperial"] = "imperial";
})(UnitSystem || (UnitSystem = {}));
var AssetPageType;
(function(AssetPageType) {
    AssetPageType["Classic"] = "classic";
    AssetPageType["Slick"] = "slick";
})(AssetPageType || (AssetPageType = {}));
var CustomButtonTypeOpenAsType;
(function(CustomButtonTypeOpenAsType) {
    CustomButtonTypeOpenAsType["Iframe"] = "iframe";
    CustomButtonTypeOpenAsType["Tab"] = "tab";
})(CustomButtonTypeOpenAsType || (CustomButtonTypeOpenAsType = {}));
var WeekDays;
(function(WeekDays) {
    WeekDays["Sunday"] = "sunday";
    WeekDays["Monday"] = "monday";
    WeekDays["Tuesday"] = "tuesday";
    WeekDays["Wednesday"] = "wednesday";
    WeekDays["Thursday"] = "thursday";
    WeekDays["Friday"] = "friday";
    WeekDays["Saturday"] = "saturday";
})(WeekDays || (WeekDays = {}));
var TourType;
(function(TourType) {
    TourType["Regular"] = "regular";
    TourType["Conference"] = "conference";
    TourType["Game"] = "game";
    TourType["ECommerce"] = "ecommerce";
    TourType["Ticket"] = "ticket";
})(TourType || (TourType = {}));
var TourTypeURL = {
    regular: "tour",
    conference: "conference-tour",
    game: "game",
    ecommerce: "e-commerce-tour",
    ticket: "ticket",
    video: "video"
};
var TourAddons = {
    title: 0,
    brand: false,
    hl: 0,
    tourcta: 1,
    dh: true,
    mt: true,
    nozoom: true,
    pin: true,
    mls: 0,
    qs: false,
    gt: true,
    portal: true,
    f: true,
    wh: true,
    kb: true,
    lp: false,
    vr: true,
    ts: -1,
    help: -1,
    nt: false
};
var AdRes;
(function(AdRes) {
    AdRes["Percentage"] = "percentage";
    AdRes["Pixels"] = "pixels";
})(AdRes || (AdRes = {}));
var Tour = /*#__PURE__*/ function() {
    "use strict";
    function Tour() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, Tour);
        this.id = model.id || null;
        this.introScreen = model.introScreen || null;
        this.subTitle = model.subTitle || null;
        this.slug = model.slug || null;
        this.useSlug = model.useSlug || false;
        this.panoramaTransition = model.panoramaTransition || false;
        this.ticket = model.ticket || false;
        this.minimapVisible = model.minimapVisible || false;
        this.pay = model.pay;
        this.waitingPayment = model.waitingPayment;
        this.clientId = model.clientId || null;
        this.userId = model.userId || null;
        this.parentId = model.parentId || null;
        this.user = model.user ? new User(model.user) : null;
        this.adLeads = model.adLeads || false;
        this.error = model.error || null;
        this.title = model.title || null;
        this.password = model.password || null;
        this.mainImage = model.mainImage || null;
        this.address = model.address || null;
        this.internalAddress = model.internalAddress || null;
        this.size = model.size || null;
        this.beds = model.beds || null;
        this.cars = model.cars || null;
        this.showers = model.showers || null;
        this.accomodation = model.accomodation || null;
        this.vrUrl = model.vrUrl || null;
        this.summary = model.summary || null;
        this.minimap = model.minimap || null;
        this.panorama = model.panorama || null;
        this.autoplayVideo = model.autoplayVideo || false;
        this.disableContext = model.disableContext || false;
        this.bookUrl = model.bookUrl || null;
        this.bookText = model.bookText || null;
        this.bookColor = model.bookColor || "#292929";
        this.exploreText = model.exploreText || null;
        this.ad = model.ad || false;
        this.share = model.share || false;
        this.adTime = model.adTime || null;
        this.adRes = model.adRes || AdRes.Percentage;
        this.adResMobile = model.adResMobile || AdRes.Percentage;
        this.adWidth = model.adWidth || 80;
        this.adHeight = model.adHeight || 60;
        this.adWidthMobile = model.adWidthMobile || 80;
        this.adHeightMobile = model.adHeightMobile || 60;
        this.adUrl = model.adUrl || null;
        this.droneUrl = model.droneUrl || null;
        this.videoUrl = model.videoUrl || null;
        this.videoWidth = model.videoWidth || null;
        this.videoHeight = model.videoHeight || null;
        this.floorPlansEnabled = model.floorPlansEnabled || false;
        this.customMinimap = model.customMinimap || false;
        this.menuEnabled = model.menuEnabled || false;
        this.menuOnStart = model.menuOnStart || false;
        this.menuAlwaysOpenMobile = model.menuAlwaysOpenMobile || false;
        this.menuAlwaysOpenDesktop = model.menuAlwaysOpenDesktop || false;
        this.music = model.music || false;
        this.autoplayMusic = model.autoplayMusic;
        this.screenshotEnabled = model.screenshotEnabled || false;
        this.status = model.status || TourStatus.Idle;
        this.matterId = model.matterId || null;
        this.images = model.images || [];
        this.width = model.width || null;
        this.height = model.height || null;
        this.ppm = model.ppm || null;
        this.originX = model.originX || null;
        this.originY = model.originY || null;
        this.floorPlans = model.floorPlans || [];
        this.tags = model.tags || [];
        this.clientFolderId = model.clientFolderId || null;
        this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
        this.client = model.client ? new Client(model.client) : null;
        this.tokenDuration = model.tokenDuration || -1;
        this.description = model.description || null;
        this.appointmentTime = model.appointmentTime || 30;
        this.fee = model.fee || 0;
        this.unitSystem = model.unitSystem || UnitSystem.Metric;
        this.appointmentsOn = model.appointmentsOn || false;
        this.agentSelecting = model.agentSelecting || false;
        this.appointmentTooltipOn = isNil_default()(model.appointmentTooltipOn) || model.appointmentTooltipOn;
        this.enableAvatar = isNil_default()(model.enableAvatar) || model.enableAvatar;
        this.getInTouchTooltipOn = isNil_default()(model.getInTouchTooltipOn) || model.getInTouchTooltipOn;
        this.menuTooltipOn = isNil_default()(model.menuTooltipOn) || model.menuTooltipOn;
        this.timezone = model.timezone || 0;
        this.sweepGroups = model.sweepGroups || [];
        this.unbranded = model.unbranded || false;
        this.translation = model.translation || null;
        this.messengerLink = model.messengerLink || null;
        this.messengerGreeting = model.messengerGreeting || null;
        this.assetPageType = model.assetPageType || AssetPageType.Classic;
        this.matterPassword = model.matterPassword || null;
        this.reel = model.reel || false;
        this.reels = model.reels || [];
        this.reelCategories = model.reelCategories || [];
        this.brightness = model.brightness || 1;
        this.saturation = model.saturation || 1;
        this.contrast = model.contrast || 1;
        this.contactForm = model.contactForm || false;
        this.panoramaStart = model.panoramaStart || false;
        this.panoramaHd = model.panoramaHd || false;
        this.hideMinimapHotspots = model.hideMinimapHotspots || false;
        this.enableVS = model.enableVS || false;
        this.allowGuestBeforeHost = model.allowGuestBeforeHost || false;
        this.qualtricsId = model.qualtricsId || null;
        this.collectLeads = model.collectLeads || false;
        this.leadsEmail = model.leadsEmail || false;
        this.leadsPhone = model.leadsPhone || false;
        this.leadsComment = model.leadsComment || null;
        this.legalNote = model.legalNote || null;
        this.legalBookingBox = model.legalBookingBox || null;
        this.legalBookingBox2 = model.legalBookingBox2 || null;
        this.termsUrl = model.termsUrl || null;
        this.enableBlackColorMenu = model.enableBlackColorMenu || false;
        this.mpReel = model.mpReel || false;
        this.mpPlay = model.mpPlay || false;
        this.hidePucks = model.hidePucks;
        this.menuSearch = model.menuSearch || false;
        this.menuCategoryExpand = model.menuCategoryExpand || false;
        this.hideCookie = model.hideCookie || false;
        this.registrationBackground = model.registrationBackground || null;
        this.conference = model.conference || null;
        this.tourEmail = model.tourEmail || {
            contactName: null,
            contactPhone: null,
            leadSweeps: null,
            leadForms: null,
            videoAppointment: null,
            assertContactIcon: null,
            assertGetInTouch: null,
            menuGetInTouch: null
        };
        this.noAudioMode = model.noAudioMode || false;
        this.mode = model.mode;
        this.gameId = model.gameId || null;
        this.hideClientContact = model.hideClientContact || false;
        this.musics = model.tourMusics || [];
        this.agents = model.agentTours && model.agentTours.map(function(agentTour) {
            return new Agent/* Agent */.P(agentTour.agent);
        });
        this.htmlActive = model.htmlActive || false;
        this.htmlCode = model.htmlCode || "";
        // URL Addons
        Object.keys(TourAddons).forEach(function(addon) {
            _this["addon_".concat(addon)] = model["addon_".concat(addon)];
        });
        this.amenities = model.amenities || null;
        this.publicId = model.matterId ? encodeURIComponent(btoa(model.matterId)) : null;
        this.scannedAt = model.scannedAt ? moment_default()(model.scannedAt).format("DD/MM/YYYY") : moment_default()().format("DD/MM/YYYY");
        this.showNavTools = model.showNavTools || false;
        this.stopAfterSweep = model.stopAfterSweep || 0;
        this.rotationAngle = model.rotationAngle || 0;
        this.rotationSpeed = model.rotationSpeed || 0;
        this.transitionSpeed = model.transitionSpeed || 0;
        this.showNavPath = model.showNavPath || false;
        this.walkNav = model.walkNav || false;
        this.teleportNav = model.teleportNav || false;
        this.autoNav = model.autoNav || false;
        this.customButton = model.customButton || false;
        this.customButtonIcon = model.customButtonIcon || null;
        this.customButtonUrl = model.customButtonUrl || null;
        this.customButtonOpenAs = model.customButtonOpenAs || CustomButtonTypeOpenAsType.Tab;
        this.ecommercePaidStatus = model.ecommercePaidStatus || false;
        this.ecommerceSubscriptionId = model.ecommerceSubscriptionId || null;
    }
    var _proto = Tour.prototype;
    _proto.getAddonsUrl = function getAddonsUrl() {
        var _this = this;
        var string = "&play=1&search=0";
        Object.keys(TourAddons).map(function(addon) {
            var value = _this["addon_".concat(addon)] ? "1" : "0";
            if (typeof _this["addon_".concat(addon)] === "number") value = _this["addon_".concat(addon)];
            if (addon === "help" && _this["addon_".concat(addon)] === -1) value = null;
            if (addon === "ts") return null; // we do our own ts logic
            string += "&".concat(addon, "=").concat(value);
            return null;
        });
        return string;
    };
    return Tour;
}();


/***/ }),

/***/ 72789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ treedisCookieName; },
/* harmony export */   "Le": function() { return /* binding */ CustomCookieConsent; },
/* harmony export */   "q7": function() { return /* binding */ allowUsesCookie; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_cookie_consent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92491);
/* harmony import */ var react_cookie_consent__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_cookie_consent__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _util_analytic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83784);



var treedisCookieName = "allow_treedis_cookie";
var allowUsesCookie = function() {
    var hide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var cookie = (0,react_cookie_consent__WEBPACK_IMPORTED_MODULE_1__.getCookieConsentValue)(treedisCookieName);
    if (cookie === undefined) {
        //no value set yet for cookie
        if (hide) {
            //message is not activated, assume we can track
            return true;
        } else {
            //message is activated, so wait for user response
            return false;
        }
    } else {
        return cookie === "true";
    }
};
function CustomCookieConsent(param) {
    var message = param.message, accept = param.accept, decline = param.decline, tour = param.tour, loaded = param.loaded;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_cookie_consent__WEBPACK_IMPORTED_MODULE_1___default()), {
        location: "bottom",
        cookieName: treedisCookieName,
        style: {
            background: "rgba(0, 0, 0, 0.6)",
            fontFamily: "Hind"
        },
        buttonText: accept || "Accept",
        buttonClasses: "primary-btn m-1",
        enableDeclineButton: true,
        declineButtonText: decline || "Decline",
        declineButtonClasses: "primary-btn black m-1",
        disableButtonStyles: true,
        onAccept: function() {
            (0,_util_analytic__WEBPACK_IMPORTED_MODULE_2__/* .startGA */ .Rj)(tour, loaded, true);
        },
        children: message || "This website uses cookies to enhance the user experience."
    });
}


/***/ }),

/***/ 40488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getBaseURL; },
/* harmony export */   "DF": function() { return /* binding */ buildLink; },
/* harmony export */   "Dv": function() { return /* binding */ getQueryVariable; },
/* harmony export */   "Jw": function() { return /* binding */ setWhiteLabel; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "R6": function() { return /* binding */ getTicketTypeCount; },
/* harmony export */   "bo": function() { return /* binding */ getVersion; },
/* harmony export */   "fg": function() { return /* binding */ downloadFloorPlan; },
/* harmony export */   "gb": function() { return /* binding */ getBucketLink; },
/* harmony export */   "i1": function() { return /* binding */ getAllQueryVariables; },
/* harmony export */   "k": function() { return /* binding */ updatePanoRotation; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "pb": function() { return /* binding */ ticketingTypes; },
/* harmony export */   "rQ": function() { return /* binding */ fetchData; },
/* harmony export */   "rp": function() { return /* binding */ getVideoLink; },
/* harmony export */   "tG": function() { return /* binding */ openLinkInNewTab; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; },
/* harmony export */   "x4": function() { return /* binding */ login; }
/* harmony export */ });
/* unused harmony exports getICEServers, getPanoramaIndex, getYoutubeVideoQueryVariable */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54453);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46021);
/* provided dependency */ var process = __webpack_require__(34155);






function getVersion(date) {
    return moment__WEBPACK_IMPORTED_MODULE_2___default()().diff(date, "days") === 0 ? "?v=".concat(moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format("HHmmss")) : "";
}
function setWhiteLabel(tour) {
    var ref;
    if (!tour || !tour.user) return;
    var client = tour.client;
    var user = ((ref = tour.user.admin) === null || ref === void 0 ? void 0 : ref.id) === 1 ? tour.user : tour.user.admin || tour.user;
    var whitelabelActive = user.whitelabelId;
    var clientLogoActive = client && client.whitelabelId && client.whitelabelLogo;
    var w = client && client.whitelabelId && clientLogoActive ? client : user;
    var c = client && client.whitelabelId ? client : user;
    var website = whitelabelActive && w.website ? w.website : "https://treedis.com";
    var logoUrl = "".concat("https://cdn.treedis.com", "/").concat(clientLogoActive ? "clients" : "users", "/").concat(clientLogoActive ? client.id : user.id, "/logo.png").concat(getVersion(clientLogoActive ? client.updatedAt : user.updatedAt));
    var whiteLabelData = {
        primaryColor: whitelabelActive ? c.primaryColor || "#292929" : "#292929",
        secondaryColor: whitelabelActive ? c.secondaryColor || "#ea475c" : "#ea475c",
        logo: whitelabelActive ? logoUrl : "/logo.png",
        website: website.includes("https://") ? website : "https://".concat(website.replace("http://", "")),
        domainUrl: whitelabelActive ? user.domainUrl || "my.treedis.com" : "my.treedis.com"
    };
    document.documentElement.style.setProperty("--color-primary", "".concat(whiteLabelData.primaryColor));
    document.documentElement.style.setProperty("--color-secondary", "".concat(whiteLabelData.secondaryColor));
    this.setState({
        whiteLabelData: whiteLabelData
    });
}
function getICEServers() {
    return _getICEServers.apply(this, arguments);
}
function _getICEServers() {
    _getICEServers = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var username, secret, res, response, servers;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    username = process.env.NEXT_PUBLIC_XIRSYS_USERNAME;
                    secret = process.env.NEXT_PUBLIC_XIRSYS_SECRET;
                    _ctx.next = 4;
                    return axios.put("https://global.xirsys.net/_turn/crm", {
                        format: "urls",
                        expire: 40
                    }, {
                        headers: {
                            Authorization: "Basic ".concat(btoa("".concat(username, ":").concat(secret)))
                        }
                    });
                case 4:
                    res = _ctx.sent;
                    response = res.data;
                    if (response) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("ICE failed to respond, please retry");
                case 8:
                    servers = response.v;
                    if (!(response.s === "ok" && servers.iceServers)) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", [
                        servers.iceServers
                    ]);
                case 11:
                    throw new Error("ICE failed to respond, please retry: ".concat(response.v));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getICEServers.apply(this, arguments);
}
function fetchData() {
    return _fetchData.apply(this, arguments);
}
function _fetchData() {
    _fetchData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _url, method, body, config, url, response, _args = arguments;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _url = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "", method = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "get", body = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, config = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {};
                    url = "v1/".concat(_url);
                    if (_url.includes("https://")) url = _url;
                    _ctx.next = 5;
                    return _axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[method.toLowerCase()](url, body, config);
                case 5:
                    response = _ctx.sent;
                    if (!(response.status === 200)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", response.data);
                case 8:
                    if (response.data) react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error(response.data.message);
                    return _ctx.abrupt("return", null);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchData.apply(this, arguments);
}
function login(password) {
    var tour = this.state.tour;
    if (tour.password === password) {
        var _this = this;
        tour.password = null;
        this.setState({
            tour: tour,
            interacted: true
        }, function() {
            if (_this.iframe) {
                _this.iframe.addEventListener("load", _this.showcaseLoader, true);
            }
        });
    } else {
        react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error("Wrong password");
    }
}
function getPanoramaIndex(panoramas, id) {
    return panoramas.findIndex(function(p) {
        return p.id === id;
    });
}
function getQueryVariable(query, variable) {
    if (!query || !variable) return false;
    query = decodeURIComponent(query.split("?")[1]);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}
function getAllQueryVariables(query) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
    if (!query) return "";
    return "".concat(prefix).concat(query.split("?").pop());
}
function getYoutubeVideoQueryVariable(query, variable) {
    if (!query || !variable) return "";
    if (getQueryVariable(query, variable)) {
        return getQueryVariable(query, variable);
    }
    return query.split("/").pop();
}
function getVideoLink(url, settings) {
    if (!url) return "";
    var autoplay;
    if (settings && typeof settings.autoplay === "boolean") {
        autoplay = settings.autoplay ? 1 : 0;
    } else {
        autoplay = (settings === null || settings === void 0 ? void 0 : settings.autoplay) === undefined ? 1 : settings === null || settings === void 0 ? void 0 : settings.autoplay;
    }
    var mute = (settings === null || settings === void 0 ? void 0 : settings.mute) === undefined ? false : settings === null || settings === void 0 ? void 0 : settings.mute;
    var muteQueryParam = mute ? "&mute=1" : "";
    var urlC = [];
    if (url.includes("https://vimeo.com/")) {
        urlC = url.split("https://vimeo.com/");
    } else if (url.includes("https://player.vimeo.com/video/")) {
        urlC = url.split("https://player.vimeo.com/video/");
    }
    if (urlC.length > 1) {
        muteQueryParam = mute ? "&&muted=1" : "";
        var subtitlesParam = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&texttrack=".concat(settings.subtitles) : "";
        return "https://player.vimeo.com/video/".concat(urlC[1], "?autoplay=").concat(autoplay, "&title=0&byline=0&portrait=0").concat(muteQueryParam).concat(subtitlesParam);
    }
    var subtitlesParam1 = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&hl=".concat(settings.subtitles) : "";
    return "https://www.youtube.com/embed/".concat(getYoutubeVideoQueryVariable(url, "v"), "?autoplay=").concat(autoplay).concat(muteQueryParam).concat(subtitlesParam1);
}
function getBaseURL() {
    return window.location.href.split("?")[0];
}
function buildLink(s, rotation) {
    var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var link = "".concat(getBaseURL(), "?s=").concat(s, "&x=").concat(rotation.x, "&y=").concat(rotation.y);
    if (m) link += "&m=".concat(m);
    var ticket = new URLSearchParams(window.location.search).get("ticket");
    if (ticket && ticket.length > 0) link += "&ticket=".concat(ticket);
    return link;
}
function hexToRgb() {
    var hex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.hex */ .K.hex;
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.rgb */ .K.rgb;
}
function copyToClipboard(text) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
        ;
        return false;
    } finally{
        document.body.removeChild(textarea);
    }
}
function updatePanoRotation(north, pos) {
    var _state = this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
    this.panoPose = pos;
    if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
    var mapNorth = minimaps[selectedMinimap].north || 0;
    var y = pos.yaw > 0 ? 360 - pos.yaw : -1 * pos.yaw;
    var diff = north - y;
    var mapWalkerRotation = mapNorth + diff;
    this.setState({
        mapWalkerRotation: mapWalkerRotation
    });
}
var downloadFloorPlan = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, plan) {
        var pdfName, pdfType, response, blob, urlTwo, link;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pdfName = (plan === null || plan === void 0 ? void 0 : plan.name) || "";
                    pdfType = (plan === null || plan === void 0 ? void 0 : plan.type) || "pdf";
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return fetch("v1/public/downloadPdf", {
                        method: "POST",
                        body: JSON.stringify({
                            url: url,
                            pdfName: pdfName
                        })
                    });
                case 5:
                    response = _ctx.sent;
                    _ctx.next = 8;
                    return response.blob();
                case 8:
                    blob = _ctx.sent;
                    urlTwo = window.URL.createObjectURL(new Blob([
                        blob
                    ]));
                    link = document.createElement("a");
                    link.href = urlTwo;
                    link.setAttribute("download", "".concat(pdfName, ".").concat(pdfType));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](2);
                    ;
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                18
            ]
        ]);
    }));
    return function downloadFloorPlan(url, plan) {
        return _ref.apply(this, arguments);
    };
}();
var validateEmail = function(email) {
    var regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,})+?$/;
    return regex.test(email);
};
var round = function(value, decimals) {
    return Number("".concat(Math.round(Number("".concat(value, "e").concat(decimals))), "e-").concat(decimals));
};
var openLinkInNewTab = function(linkText) {
    var link = document.createElement("a");
    link.href = linkText;
    link.target = "_blanc";
    document.body.appendChild(link);
    link.click();
    link.remove();
};
var getBucketLink = function(append) {
    return "".concat("https://cdn.treedis.com", "/ticketing/").concat(append);
};
var ticketingTypes = [
    {
        key: "ticketingToursByYourself",
        tourType: "tourByYourself",
        title: "Tour by yourself",
        genDeskKey: "tourByYourselfDescription"
    },
    {
        key: "ticketingGameTour",
        tourType: "experienceTour",
        title: "Experience tour",
        genDeskKey: "experienceTourDescription"
    },
    {
        key: "ticketingGuidedTour",
        tourType: "guidedTour",
        title: "Guided tour",
        genDeskKey: "guidedTourDescription"
    }, 
];
var getTicketTypeCount = function(ticketing) {
    return ticketingTypes.reduce(function(acc, ticketTypeObject, num) {
        var ref;
        if ((ref = ticketing[ticketTypeObject.key]) === null || ref === void 0 ? void 0 : ref.length) {
            acc.num += 1;
            acc.types.push(ticketTypeObject.tourType);
        }
        return acc;
    }, {
        num: 0,
        types: []
    });
};


/***/ }),

/***/ 83784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rj": function() { return /* binding */ startGA; },
/* harmony export */   "o$": function() { return /* binding */ sendToGA; }
/* harmony export */ });
/* unused harmony exports createGA, setGA */
/* harmony import */ var _common_CookieConsent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72789);

var sendToGA = function(type) {
    var obj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var w = window;
    if (w.ga) {
        w.ga("send", type, obj);
        w.ga("userViewId.send", type, obj);
    }
};
var createGA = function(id) {
    var customName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var w = window;
    if (customName) {
        w.ga("create", id, {
            name: customName,
            cookieFlags: "secure;samesite=none"
        });
    } else {
        w.ga("create", id, {
            cookieFlags: "secure;samesite=none"
        });
    }
};
var setGA = function(key, value) {
    var w = window;
    w.ga("set", key, value);
};
var startGA = function() {
    var tour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, loaded = arguments.length > 1 ? arguments[1] : void 0, cookie = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var ref, ref1;
    if (cookie === null) cookie = (0,_common_CookieConsent__WEBPACK_IMPORTED_MODULE_0__/* .allowUsesCookie */ .q7)(tour === null || tour === void 0 ? void 0 : tour.hideCookie);
    if (!tour || !loaded || !cookie) return;
    var googleViewId = ((ref = tour.client) === null || ref === void 0 ? void 0 : ref.googleViewId) || ((ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.googleViewId);
    if (googleViewId) createGA(googleViewId, "userViewId");
    createGA("UA-141667086-1"); // default treedis ga
    sendToGA("pageview");
};


/***/ }),

/***/ 54453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var baseURL = "https://api.treedis.com" || 0;
;
;
var instance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: baseURL
});
// Add a request interceptor
instance.interceptors.request.use(function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // Do something before request is sent
    if (!config.headers || !config.headers["Content-Type"]) {
        config.headers.Accept = "application/json";
        config.headers["Content-Type"] = "application/json";
    }
    if (config.url.indexOf("http") >= 0) {
        config.baseURL = null;
    }
    return config;
}, // Do something with request error
function(error) {
    return Promise.reject(error);
});
// Add a response interceptor
instance.interceptors.response.use(// Any status code that lie within the range of 2xx cause this function to trigger
// Do something with response data
function(response) {
    return response;
}, // Any status codes that falls outside the range of 2xx cause this function to trigger
// Do something with response error
function(error) {
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (instance);


/***/ }),

/***/ 46021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ DEFAULT_TAG_COLOR; }
/* harmony export */ });
/* unused harmony export TAG_DEFAULT */
/* harmony import */ var _models_Tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42725);

var DEFAULT_TAG_COLOR = {
    hex: "#EA475C",
    rgb: {
        r: 234,
        g: 71,
        b: 92
    }
};
var TAG_DEFAULT = {
    custom: true,
    title: null,
    description: null,
    positionX: null,
    positionY: null,
    positionZ: null,
    iconColor: DEFAULT_TAG_COLOR.hex,
    icon: null,
    opacity: 100,
    sid: null,
    enabled: true,
    type: _models_Tag__WEBPACK_IMPORTED_MODULE_0__/* .TagType.Text */ .Qy.Text,
    text: null,
    res: "pixels",
    whiteCircle: false,
    transparentBackground: false,
    mpTooltip: true
};


/***/ }),

/***/ 94697:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var blobToUrl = function(blob) {
    return window.URL.createObjectURL(new Blob([
        blob
    ]));
};
var existFile = function(url) {
    return new Promise(function(resolve) {
        fetch(url, {
            method: "HEAD"
        }).then(function(response) {
            return resolve(!!response.ok);
        }).catch(function() {
            return resolve(false);
        });
    });
};
var file = {
    blobToUrl: blobToUrl,
    existFile: existFile
};
/* harmony default export */ __webpack_exports__["Z"] = (file);


/***/ })

}]);